import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { profileApi } from '~/lib/request';

function useGDPR() {
  const result = useMutation({
    mutationFn: () => profileApi.get('api/profile/me/gdpr').json(),

    onSuccess: (data) => {
      const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = blobUrl;
      link.download = 'gdpr.json';
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );

      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
        link.remove();
      }, 100);
    },

    onError: (error) => {
      console.error(error);

      toast.error('Cannot download your data, please try again later');
    },
  });

  return result;
}

export default useGDPR;
